export default __webpack_public_path__ + "static/media/musn-logo.27d6c2b1.png";